/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для превью товара при наведении
   */
  app.ImagePreviewView = app.View.extend({

    el: '.hint-preview',
    layout: 'vertical',
    initialShift: 0,

    events: {
      'click .hint-thumbs-img img': 'changeImage',
      'click .hint-arrows': 'scrollThumbs',
      'click .hint-thumbs-wrapper': 'notLink'
    },

    run: function () {
      this.layout = this.$el.data('layout') || this.layout;
      this.shift = 0;
      this.template = app.helpers.TemplateHelper.getTemplate('#hint-thumbs_template');
    },

    render: function (withBigImage) {
      // TODO убрать проверку контейнера (кэш)
      var $newContainer = this.$('.hint-preview-js-container'),
        $thumbContainer = $newContainer.length ? $newContainer : this.$('.hint-thumbs');
      if (!this.$('.hint-thumbs-img').length) {
        $thumbContainer.html(this.template({
          model: this.model.toJSON(),
          withBigImage: withBigImage || false,
        }));
      }
      Backbone.trigger('hideTooltip');
      this.arrowPrev = this._getArrowPrev();
      this.arrowNext = this._getArrowNext();
      this.showArrowNext();
    },

    /**
     * Переключение картинок
     * @param e
     */
    changeImage: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.$('.hint-thumbs-img img').removeClass('current');
      var $thisThumbImg = $(e.currentTarget),
        imgSrc = $thisThumbImg.data('img');

      $thisThumbImg.addClass('current');
      this.$('.hint-img').attr('src', imgSrc);
    },

    /**
     * Прокрутка миниатюр
     * @param e
     */
    scrollThumbs: function (e) {
      var target = $(e.currentTarget),
        hintThumbsDimension = this._getThumbsDimension(),
        thumbsPosition = this.$('.hint-thumbs').position() || {},
        previewContainerSize = this._getPreviewContainerSize();
      e.preventDefault();
      e.stopPropagation();
      if (!this.shift && !this.initialShift) {
        this.initialShift = this.layout === 'vertical' ? thumbsPosition.top : thumbsPosition.left;
      }
      if (target.hasClass('arrow-down') || target.hasClass('arrow-right')) {
        if (this.shift >= (previewContainerSize - hintThumbsDimension)) {
          if (this.shift === this.initialShift) {
            this.shift = 0;
          }
          this.shift -= 74;
          this.$('.hint-thumbs').animate(this._getAnimateConfig());
          this.arrowPrev.show();
        }
      } else {
        if (this.shift < 0) {
          this.shift += 74;
          if (this.shift === 0) {
            this.shift = this.initialShift;
          }
          this.$('.hint-thumbs').animate(this._getAnimateConfig());
          this.arrowNext.show();
        }
      }
      this.showHideArrows(this.shift);
    },
    /**
     * Получение ширины или высоты контейнера в зависимости от расположения модуля.
     */
    _getPreviewContainerSize: function () {
      return this.layout === 'vertical' ? this.$el.innerHeight() : this.$el.innerWidth();
    },
    /**
     * Получение длины списка превью в пикселях в зависимости от расположения модуля.
     */
    _getThumbsDimension: function () {
      return this.layout === 'vertical' ? this.$('.hint-thumbs').innerHeight() : this.$('.hint-thumbs').innerWidth();
    },
    /**
     * Получения конфига для анимации в зависимости от расположения модуля.
     * @returns {*}
     * @private
     */
    _getAnimateConfig: function () {
      return this.layout === 'vertical' ? {top: this.shift} : {left: this.shift};
    },
    /**
     * Получение элемента стрелки прокрутки превью назад.
     * @returns {*}
     * @private
     */
    _getArrowNext: function () {
      return this.layout === 'vertical' ? this.$('.arrow-down') : this.$('.arrow-right');
    },
    /**
     * Получение элемента стрелки прокрутки превью вперед.
     * @returns {*}
     * @private
     */
    _getArrowPrev: function () {
      return this.layout === 'vertical' ? this.$('.arrow-up') : this.$('.arrow-left');
    },

    /**
     * Отображение стрелки прокрутки превью вперед
     */
    showArrowNext: function () {
      var containerMainSize = this._getPreviewContainerSize(),
        thumbsMainSize = this._getThumbsDimension();
      this.shift = this.shift > 0 ? 0 : this.shift;
      if (thumbsMainSize > containerMainSize) {
        if (this.shift === 0) {
          this.arrowNext.show();
        }
      } else {
        this.arrowNext.hide();
      }
    },
    /**
     * Показ либо скрытие стрелок в зависимости от положения карусели
     * @param shift
     */
    showHideArrows: function (shift) {
      var previewContainerSize = this._getPreviewContainerSize();
      if (shift >= 0) {
        this.arrowPrev.hide();
      }
      if (shift <= (previewContainerSize - this._getThumbsDimension())) {
        this.arrowNext.hide();
      }
    },

    /**
     * Перехват перехода по сстылке
     * @param e
     */
    notLink: function (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
})(jQuery);

}.call(window));